import { render } from "./ticketshoriz.vue?vue&type=template&id=520eb53c"
import script from "./ticketshoriz.vue?vue&type=script&lang=js"
export * from "./ticketshoriz.vue?vue&type=script&lang=js"

import "./ticketshoriz.vue?vue&type=style&index=0&id=520eb53c&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__